"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function FileRestoreIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M19.335,12.571a5.71,5.71,0,0,0-9.551,3.637L8.8,15.3l-1.15,1.251,2.6,2.4a.851.851,0,0,0,1.2-.049l2.4-2.606-1.25-1.152L11.488,16.36a4.009,4.009,0,0,1,3.81-3.595,4.015,4.015,0,1,1,.333,8.024H5.432a.888.888,0,0,1-.914-.857V4.068a.888.888,0,0,1,.914-.857h6.933V6.442a.937.937,0,0,0,.937.936h3.386V9.25h1.7V6.5L13.353,1.512H5.432A2.588,2.588,0,0,0,2.819,4.068V19.932a2.588,2.588,0,0,0,2.613,2.556H15.691v-.26l.011.26a5.716,5.716,0,0,0,3.633-9.917Zm-8.552,4.555-.161-.148.309-.013Z" })));
}
exports.default = FileRestoreIcon;
